/**
 * Firebase configuration and initialization module.
 * This module initializes the Firebase app and exports the authentication
 * service.
 *
 * @module Firebase
 */
import { initializeApp } from 'firebase/app';
import { getAuth, connectAuthEmulator } from 'firebase/auth';

import config from './config/env';

/**
 * Firebase configuration object.
 * Retrieved from the application's environment configuration.
 * @type {Object}
 */
const firebaseConfig = config.firebaseConfig;

/**
 * The initialized Firebase application instance.
 * @type {import('firebase/app').FirebaseApp}
 */
const app = initializeApp(firebaseConfig);

/**
 * Firebase Authentication service instance.
 * @type {import('firebase/auth').Auth}
 */
export const auth = getAuth(app);

// `messaging` used to be created here and exported. Nothing ever imported it,
// and `public/firebase-messaging-sw.js` -- the service worker it would have
// needed -- is commented out in its entirety and never registered. Creating it
// pulled firebase/messaging and idb into the initial bundle (22 KB) purely as
// an import side effect, and `getMessaging()` throws outright in browsers
// without push support, so it was a boot-time hazard as well as dead weight.
// Restore it alongside a real subscriber if push notifications get built.

// Connect to the auth emulator in environments that use one (local, simulation)
if (config.firebaseAuthEmulatorUrl) {
  connectAuthEmulator(auth, config.firebaseAuthEmulatorUrl);
}

export default app;
